import { Component, OnInit,Input } from '@angular/core';
import { APIService } from '../api.service';

@Component({
  selector: 'app-find-comp',
  templateUrl: './find-comp.component.html',
  styleUrls: ['./find-comp.component.scss']
})
export class FindCompComponent implements OnInit {

  @Input() isCust: any;
  @Input() mdlRef: any;
  @Input() custID: any;
  @Input() isShowCS: boolean = false;

  constructor(private apiService: APIService) { }

  selected = {
    id: '', 
    name: ''
  }
  customers: any = [];
  suppliers: any = [];
  jarvisData: any = [];
  agencyData: any = [];
  companyList: any = [];
  compRules = {
    isB2C: false
  };
  search: string = '';

  ngOnInit(): void {
 
    if(this.custID) {
      this.selected.id = this.custID;
    }

    let hCookie = this.apiService.getIDB('H', (data: any) =>{
      if(data){
        let tmptblH = data;
        this.companyList = tmptblH;
        this.customers = tmptblH.filter((c: any) => c.C == true);
        this.suppliers = tmptblH.filter((s: any) => s.S == true);
      }
    });
  }

  passBack() {
    this.mdlRef.close();
  }
  
  selectCust(obj:any) {
    if(obj.RI == '0') {
      let alt = '';
      this.isCust ? alt = 'supplier.' : alt = 'customer.';
      this.apiService.successAlert('Please select ' + alt);
      return;
    }

    let selCust = [];
    if(this.isShowCS){
      selCust = this.companyList.filter((a: any) => a.RI == obj.RI);
    } else if(this.isCust){
      selCust = this.customers.filter((a: any) => a.RI == obj.RI);
    } else {
      selCust = this.suppliers.filter((a: any) => a.RI == obj.RI);
    }
    
    this.mdlRef.close(selCust);
  }
}
